// @flow

import * as React from 'react';

type Props = {
  isOpened: boolean,
  toggle: Function,
  buttonRef: HTMLButtonElement,
  children: React.Node
}

class CloseableComponent extends React.PureComponent<Props> {
  ref: ?HTMLDivElement;

  handleClickOutside = (e: MouseEventHandler) => {
    e.stopPropagation();
    if (this.props.isOpened
      && this.ref
      && !this.ref.contains(e.target)
      && (!this.props.buttonRef || this.props.buttonRef && !this.props.buttonRef.contains(e.target))
    ) {
      this.props.toggle();
    }
  };

  handleKeyDown = (e: KeyboardEventHandler) => {
    e.stopPropagation();
    if (this.props.isOpened && e.which === 27) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('touchstart', this.handleClickOutside);
    document.addEventListener('keydown', (e) => {
      if (e.which === 27) {
        this.handleKeyDown(e);
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('touchstart', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    return (
      <div
        className="closeable-component"
        ref={(ref: ?HTMLDivElement) => {
          this.ref = ref;
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default CloseableComponent;
